import { ActionPropertyInput } from "./Property/ActionProperty";
import { useMyActionPlanContext } from "../../../context/useMyActionPlan";

type ActionPropertyQuestionsProps = unknown;
export const ActionPropertyQuestions = (_props: ActionPropertyQuestionsProps) => {
    const { startingPost, actionPlanAction } = useMyActionPlanContext();

    const elements = startingPost?.elements ?? [];

    const blocks: React.ReactElement[] =
        actionPlanAction.action.ssqProperties.flatMap((ssqProperty) => {
            const isPropertyMultilevel = !!ssqProperty.generalizations?.length;

            if (isPropertyMultilevel === false) return [];

            // Check if this property has children (multiple attributes)
            if (ssqProperty.children?.length) {
                // Handle properties with multiple attributes separately
                return ssqProperty.children.map((childProperty) => {
                    return <ActionPropertyInput key={childProperty.id} property={childProperty} />;
                });
            }

            const element = elements.find((element) => element.ssqPropertyId === ssqProperty.id);
            const elementValue = element?.value ?? "";

            return [<ActionPropertyInput key={ssqProperty.id} property={ssqProperty} value={elementValue} />];
        }) ?? [];

    if (blocks.length === 0) return null;

    return <>{...blocks}</>;
};
